import api from '@/api';

export const user = {
  namespaced: true,
  state: () => ({
    profile: {}
  }),

  getters: {
    profile: (state) => state.profile,
    profileLoaded: (state) => !!state.profile.username
  },

  actions: {
    read: async ({ commit }) => {
      try {
        let profile = JSON.parse(localStorage.getItem('profile'));
        if (!profile) {
          profile = await api.get('users/me');
          localStorage.setItem('profile', JSON.stringify(profile));
        }

        commit('read_success', profile);
      } catch (error) {
        commit('read_error');
      }
    }
  },

  mutations: {
    read_success: (state, { profile }) => {
      profile.avatar = profile.avatar || '/img/avatar.png';
      // console.log(profile);
      state.profile = profile;
    },
    read_error: (state) => {
      state.profile = {};
    },
    logout: (state) => {
      state.profile = {};
    }
  }
};
